import appConfig from '@/config';

// GA4 property of getfloorplan.com. The tag itself is loaded by the GTM-WJLCNPR container,
// so we never call gtag('config', ...) here — only events with an explicit send_to.
const GA4_ID = 'G-5ZVSH32B71';

// Non-production environments are muted so they don't pollute the production property.
// `ga4Debug: true` in the environment config (CONFIG_JSON in GitLab CI) unmutes them and
// routes their events to GA4 DebugView.
// Production never marks its events as debug: the property excludes developer traffic from
// reports, so a stray ga4Debug in the production config would silently drop the real data.
const isProduction = () => appConfig.appEnv === 'production';
const isDebug = () => !isProduction() && appConfig.ga4Debug === true;
const isEnabled = () => isProduction() || isDebug();

export const trackEvent = (name, params = {}) => {
  if (typeof window.gtag !== 'function' || !isEnabled()) return;

  const payload = { send_to: GA4_ID };
  if (isDebug()) payload.debug_mode = true;

  Object.entries(params).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== '') payload[key] = value;
  });

  window.gtag('event', name, payload);
};

// The purchase event is sent by the backend from the payment webhook, and only the browser
// knows who the visitor is — these ids travel with the order so that event joins the session.
export const getGaIds = () => new Promise((resolve) => {
  if (typeof window.gtag !== 'function') {
    resolve({});
    return;
  }

  const ids = {};
  // Checkout must not wait on analytics.
  const timer = setTimeout(() => resolve(ids), 500);
  let pending = 2;

  const collect = (key) => (value) => {
    ids[key] = value;
    pending -= 1;

    if (pending === 0) {
      clearTimeout(timer);
      resolve(ids);
    }
  };

  window.gtag('get', GA4_ID, 'client_id', collect('clientId'));
  window.gtag('get', GA4_ID, 'session_id', collect('sessionId'));
});

// 'Multi Set Pro' -> 'multi_set_pro'
export const tariffItemId = (tariff) => (tariff?.name ? tariff.name.toLowerCase().replace(/\s+/g, '_') : null);

// The spec lists the item fields flat; GA4 ecommerce reports read them from items[].
// Both are sent so neither the spec's custom dimensions nor the built-in reports come up empty.
export const tariffItemParams = (tariff, quantity = 1) => {
  const item = {
    item_id: tariffItemId(tariff),
    item_name: tariff?.name,
    price: tariff?.price,
    // Inputs hand over strings; GA4 wants a number here.
    quantity: Number(quantity) || 1,
  };

  return { ...item, items: [item] };
};
